import { gql } from '@apollo/client'

export const REFUND_PAYMENT_MUTATION = gql`
  mutation refundPayment($paymentId: ID!, $amount: Float!) {
    refundPayment(paymentId: $paymentId, amount: $amount) {
      stripeCheckoutUrl
    }
  }
`
